module.exports = __webpack_public_path__ + "static/media/01.de35da1c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/01.jpg
// module id = 21
// module chunks = 0